module.exports = __webpack_public_path__ + "static/logo-dd1913f8c69a4135c751988fa140699a.png";